import { makeObservable, observable } from 'mobx'
import { api } from '@/helpers/api'

class AdminService {
  @observable userData: any = null

  constructor() {
    makeObservable(this)
  }

  public init() {
    this.getUserInfo()
  }

  public async getUserInfo() {
    try {
      const data = await api.admin.getUserList('test')
      if (data?.success) {
        this.userData = true
      }
    } catch (error) {}
  }
}

export const adminService = new AdminService()
